import { PaginationResult } from "../../../../Shared/Model/PaginationResult";
import { User } from "../../Domain/Model/User";
import { Users } from "../../Domain/Model/Users";
import { UserState } from "../../Domain/Model/UserState";
import { UserRepository } from "../../Domain/Repository/UserRepository";
import UserDataSource from "../DataSource/UserDataSource";

export class UserRepositoryImpl implements UserRepository{
    dataSource: UserDataSource;
    
    constructor(_datasource: UserDataSource) {
      this.dataSource = _datasource;
    }
    getUsers(page: number, pageSize: number, search: string): Promise<PaginationResult<Users>> {
      return this.dataSource.getUsers(page, pageSize, search);
    }
    createusers(data: User): Promise<boolean> {
      return this.dataSource.createusers(data);
    }
    updateStateUser(data: UserState): Promise<boolean> {
      return this.dataSource.updateStateUser(data);
    }
    removeUser(id: string): Promise<boolean> {
        return this.dataSource.removeUser(id);
    }
    updateUser(data: User): Promise<boolean> {
        return this.dataSource.updateUser(data);
    }

}